import { Plugin } from '@uppy/core';
import axios from 'axios';
import FormData from 'form-data';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import qs from 'qs';
import { osName, osVersion } from 'react-device-detect';
import appJson from '../../../../package.json';
import settle from './settle';

class UppyUploadPlugin extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.type = 'uploader';
    this.id = this.opts.id || 'UppyUploadPlugin';
    this.title = 'UppyUploadPlugin';
    const appver = appJson.version;
    const AppKey = 'desktop';

    this.defaultData = { os: osName, osver: osVersion, appver, AppKey };
  }

  getConfig = (file) => {
    return {
      onUploadProgress: (progressEvent) => {
        this.uppy.emit('upload-progress', file, {
          uploader: this,
          bytesUploaded: progressEvent.loaded,
          bytesTotal: progressEvent.total,
        });
      },
    };
  };

  uploadSuccess = (response, file) => {
    const uploadResp = {
      status: response.status,
      body: response.data,
      uploadURL: response.request.uploadURL,
    };
    this.uppy.emit('upload-success', file, uploadResp);
  };

  uploadError = (error, file) => {
    const res = { status: error.status };
    this.uppy.emit('upload-error', file, error, res);
  };

  uploadImage = async (file) => {
    try {
      const config = this.getConfig(file);
      const data = new FormData();
      _forEach(this.defaultData, (value, key) => {
        data.append(key, value);
      });
      data.append('Image', file.data);
      data.append('Type', this.opts.uploadType);
      const url = `${this.opts.server}${this.opts.imageEndpoint}/${this.opts.sessionToken}`;
      const r = await axios.post(url, data, config);
      return this.uploadSuccess(r, file);
    } catch (e) {
      return this.uploadError(e, file);
    }
  };

  uploadVideo = async (file, resolve, reject) => {
    // TODO: Ask for more allowed types (other than mov)
    // const extension = (file.type || '').split('/')[1];
    try {
      const data = {
        ...this.defaultData,
        FileType: 'mov',
        Type: this.opts.uploadType,
      };
      const url = `${this.opts.server}${this.opts.videoEndpoint}/${this.opts.sessionToken}`;
      const response = await axios.post(url, qs.stringify(data));
      // const config = this.getConfig(file);
      const s3Url = _get(response, 'data.payload.URLs.0.URL');
      if (!s3Url) {
        this.uploadError(new Error('Something went wrong!'), file, reject);
      }
      const config = {
        ...this.getConfig(file),
        headers: { 'Content-Type': file.type },
      };
      await axios.put(s3Url, file.data, config);
      return this.uploadSuccess(response, file, resolve);
    } catch (e) {
      return this.uploadError(e, file, reject);
    }
  };

  upload = async (file) => {
    this.uppy.emit('upload-started', file);
    const fileType = (file.type || '').split('/')[0];
    switch (fileType) {
      case 'image':
        return this.uploadImage(file);
      case 'video':
        return this.uploadVideo(file);
      default:
        return null;
    }
  };

  uploadFiles = (files) => {
    const promises = files.map((file, i) => {
      const current = parseInt(i, 10) + 1;
      const total = files.length;

      if (file.error) {
        return Promise.reject(new Error(file.error));
      }
      return this.upload(file, current, total);
    });

    return settle(promises);
  };

  handleUpload = async (fileIDs) => {
    if (fileIDs.length === 0) {
      return Promise.resolve();
    }
    const files = fileIDs.map((fileID) => this.uppy.getFile(fileID));
    return this.uploadFiles(files);
  };

  install = () => {
    this.uppy.addUploader(this.handleUpload);
  };

  uninstall = () => {
    this.uppy.removeUploader(this.handleUpload);
  };
}

export default UppyUploadPlugin;
